import React from 'react';
import { Grid, IconButton, TextField } from '@material-ui/core';
import { Add as AddIcon } from '@material-ui/icons';
import { Autocomplete } from '@material-ui/lab';
import usePrompts from '@hooks/usePrompts';
import popup from '@components/core/Popup';
import EditDialog from '@/pages/prompts/EditDialog';

export default function PromptSelector({ onSelect }) {
  const { prompts, create } = usePrompts();

  const handleAdd = () => {
    popup({
      title: '新增 Prompt',
      content: <EditDialog onCreate={create} />,
    });
  };

  return (
    <Grid container spacing={1} alignItems="center">
      <Grid item xs={11}>
        <Autocomplete
          options={prompts}
          getOptionLabel={(option) => option.name || ''}
          onChange={(e, value) => {
            if (value) {
              onSelect(value);
            }
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              variant="outlined"
              label="選擇常用 Prompt"
              size="small"
            />
          )}
        />
      </Grid>
      <Grid item xs={1}>
        <IconButton onClick={handleAdd} size="small">
          <AddIcon />
        </IconButton>
      </Grid>
    </Grid>
  );
}
